<template>
  <div class="">
    <h5 class="d-inline">
      <strong>Payment status:</strong>&nbsp;
      <icon :icon="['fad', 'hourglass-start']" class="" v-if="status === 'not_paid'"/>
      <icon :icon="['fad', 'hourglass-half']" class="" v-else-if="status === 'paid_process'"/>
      <icon :icon="['fad', 'check']" class="" v-else-if="status === 'paid'"/>
      {{ status }}
    </h5>
    <button class="btn btn-sm btn-primary" v-on:click="refreshPayment()" :disabled="pausedFor5Seconds">
      <icon :icon="['fad', 'sync']" class=""/>&nbsp;Refresh
    </button>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  props: ['abstract_id'],
  name: "payment_status",
  created() {
    this.refreshPayment();
  },
  data() {
    return {
      pausedFor5Seconds: false,
      status: 'unknown',
    }
  },
  computed: {
    ...mapState([
      'abstract'
    ]),
  },
  methods: {
    ...mapActions('payment', ['GET_PAYMENT_STATUS']),
    async refreshPayment() {
      this.pause();
      await this.GET_PAYMENT_STATUS(this.abstract_id).then((result) => {
        if (result.data.paid === true) {
          this.status = 'paid';
          this.abstract.paid = true;
          this.abstract.payment_id = result.data.payment_id;
          this.abstract.invoice_id = result.data.invoice_id;
          this.$emit('abstract_paid');
        } else if (result.data.payment_process === true) {
          this.status = 'paid_process';
        }
      }).catch((error) => {
        this.status = 'not_paid';
      });
    },
    pause() {
      this.pausedFor5Seconds = true;
      setTimeout(() => this.pausedFor5Seconds = false, 5000);
    }
  }
}
</script>

<style scoped>

</style>
